/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class meevoCentralOfficeBar implements angular.IDirective {
        restrict = "E";
        scope = {
            ownerDisplayName: "=",
            locationDisplayName: "=",
            accessibleLocationCount: "=",
            totalLocationCount: "="
        };
        templateUrl = "app/components/controls/coNotificationBarTemplate.html";

        link = (scope, element, attrs) => {
            scope.isCOMode = this.identityService.inCentralOfficeMode();
            scope.isSingleLocation = this.identityService.current().isSingleLocation;
            //scope.showExistsIn = (this.identityService.inCentralOfficeMode())
        }

        constructor(private identityService: Meevo.Components.Common.IIdentityService) {
        }
        static factory(): angular.IDirectiveFactory {
            let directive = (identityService: Meevo.Components.Common.IIdentityService) => {
                return new meevoCentralOfficeBar(identityService);
            };
            directive.$inject = ["meevo.components.common.IdentityService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoCentralOfficeBar", meevoCentralOfficeBar.factory());
}